import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Palette } from 'config';
import { useTimeout } from 'utils';
import PropTypes from 'prop-types';

const Global = ({ delay = 500 }) => {
  const show = useTimeout(delay);

  return (
    <>
      {show && (
        <Backdrop open sx={{ background: 'rgba(0,0,0,0.5)', zIndex: '10000' }}>
          <CircularProgress sx={{ color: '#CBD5E1' }} />
        </Backdrop>
      )}
    </>
  );
};

const Local = ({ delay = 500 }) => {
  const show = useTimeout(delay);

  return (
    <>
      {show && (
        <div style={loaderStyles}>
          <CircularProgress sx={{ color: '#CBD5E1' }} />
        </div>
      )}
    </>
  );
};

const Loader = { Global, Local };

const types = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
};

Global.propTypes = types;
Local.propTypes = types;

export default Loader;

const loaderStyles = {
  width: '100%',
  textAlign: 'center',
  // marginTop: '32px',
  fontWeight: '400',
  fontSize: '0.75em',
  lineHeight: '1em',
  color: `${Palette.PrimaryGray._700}`,
};
